import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public',
  template: '<router-outlet><app-spinner></app-spinner></router-outlet>'
})
export class PublicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/PROD-mufit-web/src/app/layout/public/public.component.ts